import React from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import { UserRoles } from '../AuthDataProvider';


interface IUserRoleProps {
    role: UserRoles
}

export default function UserRole(props: IUserRoleProps) {
    switch (props.role) {
        case UserRoles.admin:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Admin">
                    <Icon>
                    manage_accounts
                </Icon>
                </Tooltip>
                </div>
            )
        case UserRoles.art:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="User">
                    <Icon>
                    person
                </Icon>
                </Tooltip>
                </div>
            )
        case UserRoles.dataScientist:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Data Scientist">
                    <Icon>
                    science
                </Icon>
                </Tooltip>
                </div>
            )
        case UserRoles.reviewer:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Reviewer">
                    <Icon>
                    rate_review
                </Icon>
                </Tooltip>
                </div>
            )
        case UserRoles.allUnauthed:
            return (
                <div style={{ display: 'inline-flex' }}>
                    Unauthed
                </div>
            )      
        default:
            return(props.role)
    }

}